module.exports = __webpack_public_path__ + "img/ideation-04-keyfeature-sample-02.7c66b779.jpg";